import React from 'react'
import EducationCard from './EducationCard'
import V2EducationCard from './V2EducationCard'

const Education = () => {
  return (
    <section id='Education'>
        <div className="education-wrap">
            <h1>My Education</h1>
            <div className="education-content">
                <EducationCard />
                {/* <V2EducationCard /> */}
            </div>
        </div>
    </section>
  )
}

export default Education